import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const TrueLogo = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="800"
    width="1200"
    viewBox="-60.6249 -36.69825 525.4158 220.1895"
  >
    <path
      d="M150.555 28.683h-4.69c-26.59 0-48.107 21.487-48.107 48.145v68.615h34.656V78.505c0-10.053 8.073-18.059 18.141-18.059h20.262V28.683zm174.438 45.704c.371-10.795 10.35-19.557 22.704-19.557 12.568 0 22.614 8.665 22.792 19.557zm79.143 16.167c-.26-36.147-19.921-64.6-56.44-64.6-31.324 0-56.684 25.344-56.684 60.237 0 37.647 23.03 59.935 56.937 60.602 22.02 0 41.289-12.36 51.12-30.516l-31.711-8.295c-3.858 5.773-11.24 9.78-19.661 9.78-12.354 0-22.333-8.867-22.704-19.618h79.143c.067-1.691 0-5.802 0-7.59m-154.25 7.753c0 9.905-8.08 18.104-18.17 18.104-9.986 0-17.985-8.199-17.985-18.104v-52.9c0-9.208-7.449-16.724-16.76-16.724h-18.059v65.091c0 29.307 15.855 53.02 52.804 53.02 37.045 0 52.849-23.713 52.849-53.02v-65.09h-34.679v69.623M51.01 0H16.36v28.683H0v31.763h16.36v37.23c0 29.181 23.616 47.767 52.782 47.767h20.455v-30.39H69.09c-9.972 0-18.081-8.117-18.081-18.089V60.446l22.71-.082c8.837-.378 15.878-7.627 15.878-16.649V28.683H51.009V0"
      fill="#ec2127"
      fillRule="evenodd"
    />
  </svg>,
  'TrueLogo'
);
